import posthog from '@leyan/lytics';
import { LRUMap } from 'lib/lruMap';

const sendTimestampMap = new LRUMap<Conversation.Conversation['conversationId'], number>(200);
const msgTypesMap = new LRUMap<Conversation.Conversation['conversationId'], string>(200);

export const setMsgTypes = (
  conversationId: Conversation.Conversation['conversationId'],
  msgTypes: string,
) => {
  msgTypesMap.set(conversationId, msgTypes);
};

export const getMsgTypes = (conversationId: Conversation.Conversation['conversationId']) => {
  return msgTypesMap.get(conversationId);
};

export const clearMsgTypes = (conversationId: Conversation.Conversation['conversationId']) => {
  msgTypesMap.delete(conversationId);
};

export const setSendTimestamp = (
  conversationId: Conversation.Conversation['conversationId'],
  timestamp: number,
) => {
  sendTimestampMap.set(conversationId, timestamp);
};

export const getSendTimestamp = (conversationId: Conversation.Conversation['conversationId']) => {
  return sendTimestampMap.get(conversationId);
};

export const clearSendTimestamp = (conversationId: Conversation.Conversation['conversationId']) => {
  sendTimestampMap.delete(conversationId);
};

export const captureDuration = (
  conversationId: Conversation.Conversation['conversationId'],
  eventName: string,
  clear = false,
) => {
  const sendTimestamp = getSendTimestamp(conversationId);
  const msgTypes = getMsgTypes(conversationId);
  if (sendTimestamp) {
    const duration = Date.now() - sendTimestamp;
    console.log(
      `[captureDuration] ${eventName} duration: ${duration} conversationId: ${conversationId}`,
    );
    posthog.capture(eventName, {
      duration,
      conversationId,
      msgTypes: msgTypes || '',
    });

    if (clear) {
      clearSendTimestamp(conversationId);
      clearMsgTypes(conversationId);
    }
  }
};
